import { combineReducers } from 'redux';
import { UserReducer } from './UserReducer';
import { clientPathReducer } from './clientPathReducer';
import { MessageReducer } from './MessageReducer';

import { ClientDataReducer } from './ClientDataReducer';
import { SearchDataReducer } from './SearchDataReducer';
import { FileDataReducer } from './FileDataReducer';
import { FileTypeDataReducer } from './FileTypeDataReducer';
import { FileMetaDataCategoryReducer } from './FileMetaDataCategoryReducer';
import { FileMetaDataValueReducer } from './FileMetaDataValueReducer';
import { FrontEndUserReducer } from './FrontEndUserReducer';
import { FileReducer } from './FileReducer';
import { ProductReducer } from './ProductReducer';
import { ReportReducer } from './ReportReducer';
import { loadingBarReducer } from 'react-redux-loading-bar'
import { LoaderReducer } from './LoaderReducer';
import { persistCombineReducers } from 'redux-persist'
import localForage from 'localforage';
const loadingBar = loadingBarReducer;
const config = {
  key: 'root',
  storage : localForage,
    whitelist: ['UserReducer', 'ClientDataReducer', 'FileMetaDataCategoryReducer', 'FileMetaDataValueReducer', 'FrontEndUserReducer', 'FileReducer']
}


const rootReducer = persistCombineReducers(config, {
  UserReducer,
  clientPathReducer,
  MessageReducer,
  ClientDataReducer,
  SearchDataReducer,
  FileDataReducer,
  FileTypeDataReducer,
  FileMetaDataCategoryReducer,
  FileMetaDataValueReducer,
  ProductReducer,
  FileReducer,
  FrontEndUserReducer,
  loadingBar,
  LoaderReducer,
  ReportReducer

});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js